<template>
  <single-image
    v-bind="$attrs"
    accept=".png,.jpg"
    :inputId="inputId"
    :schema="schema"
    :mediaURL="mediaURL"
    :queryString="queryString"
    @error="handleError"
  />
</template>

<script>
import { SingleImage } from '@witkac/vue-images';

import { uploadMixin } from '../../mixins/upload';

// @vuese
// @group Components/Forms
// Input na obrazki
export default {
  mixins: [uploadMixin],
  components: { SingleImage }
};
</script>
